/* ESK product compare - up to 4 products, stored in localStorage, compare page at /pages/compare */
(function () {
  var KEY = 'esk-compare', MAX = 4, PAGE = '/pages/compare';
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} sync(); }
  function has(h) { return load().some(function (x) { return x.h === h; }); }
  function money(c) { return c == null ? '' : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(c / 100); }
  var note = '';

  function toggle(h) {
    var a = load(), i = a.findIndex(function (x) { return x.h === h; });
    if (i > -1) { a.splice(i, 1); note = ''; save(a); return; }
    if (a.length >= MAX) { note = 'You can compare up to ' + MAX + ' products - remove one first.'; sync(); return; }
    note = '';
    a.push({ h: h, t: '', img: '' }); save(a);
    fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var b = load(), x = b.find(function (y) { return y.h === h; });
      if (x) { x.t = p.title; x.img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : ''; save(b); }
    }).catch(function () {});
  }

  function bar() {
    var el = document.getElementById('esk-cmp-bar');
    if (!el) { el = document.createElement('div'); el.id = 'esk-cmp-bar'; el.className = 'esk-cmp-bar'; el.hidden = true; el.setAttribute('role', 'region'); el.setAttribute('aria-label', 'Compare products'); document.body.appendChild(el); }
    return el;
  }

  var lastBar = null;
  function sync() {
    var a = load();
    document.querySelectorAll('[data-esk-compare]').forEach(function (b) {
      var v = has(b.getAttribute('data-esk-compare')) ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== v) b.setAttribute('aria-pressed', v);
    });
    if (document.getElementById('esk-cmp-table')) return; // no floating bar on the compare page itself
    var sig = JSON.stringify(a) + '|' + note;
    if (sig === lastBar) return; // nothing changed - don't rebuild (prevents flicker and lost taps)
    lastBar = sig;
    var el = bar();
    if (!a.length) { el.hidden = true; el.innerHTML = ''; return; }
    el.hidden = false;
    el.innerHTML = '<div class="esk-cmp-bar__thumbs">' + a.map(function (x) { return x.img ? '<img src="' + x.img + '" alt="' + (x.t || '').replace(/"/g, '&quot;') + '" loading="lazy">' : ''; }).join('') + '</div>' +
      '<span>' + (note || (a.length + ' of ' + MAX + ' selected')) + '</span>' +
      '<a class="esk-cmp-go" href="' + PAGE + '"' + (a.length < 2 ? ' aria-disabled="true" title="Pick at least 2 products"' : '') + '>Compare (' + a.length + ')</a>' +
      '<button type="button" data-esk-cmp-clear>Clear</button>';
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-esk-compare]');
    if (b) { e.preventDefault(); e.stopPropagation(); if (b._eskBusy) return; b._eskBusy = true; setTimeout(function () { b._eskBusy = false; }, 350); toggle(b.getAttribute('data-esk-compare')); return; }
    if (e.target.closest('[data-esk-cmp-clear]')) { note = ''; save([]); }
    var rm = e.target.closest('[data-esk-cmp-rm]');
    if (rm) { var h = rm.getAttribute('data-esk-cmp-rm'); save(load().filter(function (x) { return x.h !== h; })); renderPage(); }
  }, true);

  // cards injected later (filters, infinite scroll, quick view) get their state too
  var t; new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var ns = muts[i].addedNodes;
      for (var j = 0; j < ns.length; j++) {
        var n = ns[j];
        if (n.nodeType === 1 && !n.closest('#esk-cmp-bar') && (n.matches('[data-esk-compare]') || n.querySelector('[data-esk-compare]'))) { clearTimeout(t); t = setTimeout(sync, 120); return; }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { sync(); renderPage(); } });

  /* ---------- compare page ---------- */
  var ROWS = [
    ['price', 'Price', null, 'low'],
    ['available', 'Availability'],
    ['vendor', 'Brand'],
    ['product_category', 'Type'],
    ['capacity_wh', 'Battery capacity', 'Wh', 'high'],
    ['expandable_to_wh', 'Expandable to', 'Wh', 'high'],
    ['rated_power_w', 'Continuous output', 'W', 'high'],
    ['surge_power_w', 'Surge power', 'W', 'high'],
    ['max_solar_input_w', 'Max solar input', 'W', 'high'],
    ['total_panel_watts', 'Solar panels included', 'W', 'high'],
    ['panel_count', 'Panel count'],
    ['panel_design', 'Panel type'],
    ['mppt_count', 'MPPT trackers'],
    ['inverter_type', 'Inverter type'],
    ['ac_output_voltage', 'AC output voltage'],
    ['phase', 'Phase'],
    ['system_voltage', 'System voltage'],
    ['battery_chemistry', 'Battery chemistry'],
    ['capacity_ah', 'Capacity', 'Ah', 'high'],
    ['cycle_life', 'Cycle life', 'cycles', 'high'],
    ['efficiency_pct', 'Efficiency', '%', 'high'],
    ['ac_outlets', 'AC outlets', null, 'high'],
    ['usb_c_ports', 'USB-C ports', null, 'high'],
    ['connectivity', 'Connectivity'],
    ['ip_rating', 'IP rating'],
    ['self_heating', 'Self-heating'],
    ['certifications', 'Certifications'],
    ['weight_lb', 'Weight', 'lb', 'low'],
    ['warranty_years', 'Warranty', 'years', 'high'],
    ['applications', 'Best for']
  ];
  function val(p, k) { return k === 'price' || k === 'available' || k === 'vendor' ? p[k] : (p.specs || {})[k]; }
  function show(v, unit) {
    if (v == null || v === '' || (Array.isArray(v) && !v.length)) return '-';
    if (Array.isArray(v)) return v.join(', ');
    if (typeof v === 'boolean') return v ? 'Yes' : 'No';
    if (typeof v === 'number') return v.toLocaleString('en-US') + (unit ? ' ' + unit : '');
    return String(v) + (unit && /^[0-9.]+$/.test(String(v)) ? ' ' + unit : '');
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function renderPage() {
    var box = document.getElementById('esk-cmp-table'); if (!box) return;
    var a = load();
    if (a.length < 1) { box.innerHTML = '<div class="esk-cmp-empty"><p>No products selected yet. Tick "Compare" on up to ' + MAX + ' products.</p><p><a href="' + (box.getAttribute('data-empty-url') || '/collections/all') + '">Browse products</a></p></div>'; return; }
    Promise.all(a.map(function (x) {
      return fetch('/products/' + x.h + '?view=esk-compare').then(function (r) { return r.text(); }).then(function (t) { try { return JSON.parse(t); } catch (e) { return null; } }).catch(function () { return null; });
    })).then(function (ps) {
      ps = ps.filter(Boolean);
      var head = '<thead><tr><th scope="row"></th>' + ps.map(function (p) {
        var cap = p.compare_at && p.compare_at > p.price ? '<s>' + money(p.compare_at) + '</s>' : '';
        return '<td>' + (p.image ? '<a href="' + p.url + '"><img src="' + p.image + '" alt="' + esc(p.title) + '" loading="lazy"></a>' : '') +
          '<a class="esk-cmp-title" href="' + p.url + '">' + esc(p.title) + '</a><div class="esk-cmp-price">' + money(p.price) + cap + '</div>' +
          '<button type="button" class="esk-cmp-rm" data-esk-cmp-rm="' + p.handle + '">Remove</button></td>';
      }).join('') + '</tr></thead>';
      var body = ROWS.map(function (r) {
        var k = r[0], vals = ps.map(function (p) { return val(p, k); });
        if (vals.every(function (v) { return v == null || v === '' || (Array.isArray(v) && !v.length); })) return '';
        var nums = vals.map(function (v) { return typeof v === 'number' ? v : null; }), best = null;
        if (r[3] && ps.length > 1 && nums.filter(function (n) { return n != null; }).length > 1) {
          var f = nums.filter(function (n) { return n != null; });
          best = r[3] === 'high' ? Math.max.apply(null, f) : Math.min.apply(null, f);
        }
        var same = vals.every(function (v) { return JSON.stringify(v) === JSON.stringify(vals[0]); });
        return '<tr class="' + (same ? 'esk-same' : '') + '"><th scope="row">' + r[1] + '</th>' + vals.map(function (v, i) {
          var txt = k === 'price' ? money(v) : k === 'available' ? (v ? '<span class="esk-cmp-in">In stock</span>' : '<span class="esk-cmp-out">Sold out</span>') : esc(show(v, r[2]));
          return '<td' + (best != null && nums[i] === best && !same ? ' class="esk-best"' : '') + '>' + txt + '</td>';
        }).join('') + '</tr>';
      }).join('');
      box.innerHTML = '<div class="esk-cmp-tools"><label><input type="checkbox" id="esk-cmp-diff"> Show only differences</label><button type="button" class="esk-cmp-rm" data-esk-cmp-clear>Clear all</button></div>' +
        '<div class="esk-cmp-scroll"><table class="esk-cmp"><caption class="visually-hidden">Product comparison</caption>' + head + '<tbody>' + body + '</tbody></table></div>';
      var d = document.getElementById('esk-cmp-diff');
      d.addEventListener('change', function () { box.querySelectorAll('tbody tr').forEach(function (tr) { tr.classList.toggle('esk-cmp-diff-off', d.checked); }); });
    });
  }

  function init() { sync(); renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('click', function (e) { if (e.target.closest('[data-esk-cmp-clear]') && document.getElementById('esk-cmp-table')) setTimeout(renderPage, 0); });
})();
